import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { paymentApi } from '@formosa/shared/api/payment';
import { resolveImageUrl } from '../../constants/depositConstants';
import { useTranslation } from '../../i18n/LocaleContext';

export default function OfflineCurrencyListPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const merchant = location.state?.merchant || null;

  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    paymentApi
      .listOfflineDepositAddresses()
      .then((rows) => {
        if (!cancelled) {
          setAddresses(Array.isArray(rows) ? rows : []);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message || t('deposit.loadAddressesFailed'));
          setAddresses([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [t]);

  return (
    <div className="deposit-page">
      <header className="deposit-page__header">
        <button
          type="button"
          className="deposit-page__back"
          aria-label={t('common.back')}
          onClick={() => navigate(-1)}
        >
          ‹
        </button>
        <h1>{merchant?.displayName || t('deposit.offlineTitle')}</h1>
        <span className="deposit-page__header-spacer" />
      </header>

      {loading && <p className="deposit-page__status">{t('common.loading')}</p>}
      {error && <p className="deposit-page__error">{error}</p>}

      {!loading && !error && (
        <ul className="deposit-currency-list">
          {addresses.length === 0 ? (
            <li className="deposit-page__empty">{t('common.noData')}</li>
          ) : (
            addresses.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  className="deposit-currency-item"
                  onClick={() => navigate(`/deposit/offline/${item.id}`, {
                    state: { merchant, address: item },
                  })}
                >
                  <span className="deposit-currency-item__icon" aria-hidden>
                    {item.image ? (
                      <img src={resolveImageUrl(item.image)} alt="" />
                    ) : (
                      <span>₮</span>
                    )}
                  </span>
                  <span className="deposit-currency-item__label">{item.label}</span>
                  <span className="deposit-currency-item__add" aria-hidden>
                    +
                  </span>
                </button>
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  );
}
